import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { getOnePeopleById } from "../../config/WeChatPeopleConfig";
import { WeChatPeople } from "../../manager/WeChatConst";
import normalEventNewBase from "./normalEventNewBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class normalEvent_LoveStroy extends normalEventNewBase {

    async loadEvent(){
        let peopleId = this.eventData.peopleId;
        let people:WeChatPeople = getOnePeopleById(peopleId);
        let headUrl:string = null;
        if(people){
            headUrl = people.headUrl;
        }
        this.headSp.getComponent(cc.Sprite).spriteFrame = null;
        this.lb_Dec.string = "";
        if(headUrl){
            getOneBundle(BUNDLE_SMALL_NAME.WeChatGameBundle).then((bundle:cc.AssetManager.Bundle)=>{
                bundle.load(headUrl,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                    if(err){
                        console.log(err);
                    }else{
                        this.headSp.getComponent(cc.Sprite).spriteFrame = asset;
                    }
                });
            });
        }

        let objPath:string = this.eventData.objSp;
        if(objPath!=null){
            this.spNode.active = true;
            getOneBundle(BUNDLE_SMALL_NAME.WeChatGameBundle).then((bundle:cc.AssetManager.Bundle)=>{
                bundle.load(headUrl,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                    if(err){
                        console.log(err);
                    }else{
                        this.headSp.getComponent(cc.Sprite).spriteFrame = asset;
                    }
                });
            });
        }else{
            this.spNode.active = false;
        }

        // this.centerNode.scale = 0;
        // cc.tween(this.centerNode).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
        this.updateChoose();
    }
    
}
